import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';
import {Simulador} from '../../classes/simulador';

declare var $: any;

@Component({
  selector: 'app-pergunta',
  templateUrl: './pergunta.component.html',
  styleUrls: ['./pergunta.component.css']
})
export class PerguntaComponent implements OnInit {
  @Input('index') index: number;
  @Input('pergunta') pergunta;
  @Input('contador') contador: number;

  @Output() finalizado = new EventEmitter();
  @Output() voltar = new EventEmitter();

  constructor(public simulador: Simulador) {

  }

  ngOnInit() {
    this.validate();
  }

  _voltar(index) {
    this.voltar.emit();
  }

  validate() {
    const self  = this;
    const regex = new RegExp(self.pergunta.regex || '.*');

    if (!self.pergunta.required) {
      self.pergunta.valid = true;
    } else {
      self.pergunta.valid = (self.pergunta.fieldValue && regex.test(self.pergunta.fieldValue));
    }
  }

  finalizar(form) {
    const self = this;

    self.validate();

    if (self.pergunta.valid) {
      self.finalizado.emit();
    } else {
      $('#pergunta-' + self.index).shake();
    }
  }

  check(pergunta, valor, form) {
    const self = this;

    pergunta.fieldValue = valor;
    self.validate();
    self.finalizar(form);
  }
}
